import { render } from "./ImagesCarousel.vue?vue&type=template&id=f4595e56&ts=true"
import script from "./ImagesCarousel.vue?vue&type=script&lang=ts"
export * from "./ImagesCarousel.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__